<template>
  <div
    :id="htmlId"
    v-help.mouse="`Kliknutím změníte hodnotu na opačnou tedy ANO => NE nebo NE => ANO`"
    class="bool-switch asd-input"
    :class="{'asd-input-disabled': visibility > 0}"
  >
    <div
      v-if="valueHandler === null"
      v-help.mouse="'Otazník značí že hodnota je zatím nezvolena.'"
      class="switch-unknown"
      @click="valueHandler = true"
    >
      Nedefinováno
    </div>
    <div
      v-if="valueHandler === true"
      class="switch-yes"
      @click="valueHandler = false"
    >
      Ano
    </div>
    <div
      v-if="valueHandler === false"
      class="switch-no"
      @click="valueHandler = true"
    >
      Ne
    </div>
  </div>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'
import _ from 'lodash'
import { createDataTypeValue } from '../utils'

export default {
    name: 'BooleanInput',
    mixins: [
        DataTypeProsMixin,
    ],
    computed: {
        valueHandler: {
            get() {
                return _.get(this, 'value.value.value', null)
            },
            set(value) {
                if (this.visibility === 0) {
                    this.$emit('input', createDataTypeValue(value))
                }
            },
        },
    },
    mounted() {
        const { enabled, value } = _.get(this, 'propertyType.settings.default_static_value', {
            enabled: false,
            value: undefined,
        })
        if (enabled && this.valueHandler === null) {
            this.valueHandler = value
        }
    },
}
</script>

<style lang="scss" scoped>
.bool-switch {
    color: silver;
    padding-top: 5px;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    .switch-yes {
        color: green;
    }
    .switch-no {
        color: red;
    }
}
</style>
